// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"61c7a73d","312":"a6c6e9f7","327":"55b77f77","362":"85532a99","406":"46dc24a2","417":"e72c172c","507":"e0b96508","551":"5a281d88","906":"a6c6e9f7","975":"e72c172c"}[chunkId] + ".chunk.css";
};